import { render, staticRenderFns } from "./FileDownloadHolder.vue?vue&type=template&id=2aa16b53&scoped=true&"
import script from "./FileDownloadHolder.vue?vue&type=script&lang=js&"
export * from "./FileDownloadHolder.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadHolder.vue?vue&type=style&index=0&id=2aa16b53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa16b53",
  null
  
)

export default component.exports